import React from 'react';
import { URL } from 'utils/url-builder';
import { SectionPage } from 'components/ui/skeletons/section-page';
import { ActionList } from './action-list';
import { ActionPage } from './action-page';

export const ActionsPage = () => {
  return <SectionPage sectionListUrl={URL.actionList()} listComponent={ActionList} pageComponent={ActionPage} />;
};
